import axios from 'axios'

export async function downloadFile(backPath, type, id, user_id, process_id, path) {
  const fileName = path.split('/').pop()
  const url = `${backPath}/regular-applications/${type}/${id}/${user_id}/${process_id}/${fileName}`

  const response = await axios.get(url, {
    responseType: 'blob',
  })

  const blob = new Blob([response.data])

  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = fileName
  link.click()

  window.URL.revokeObjectURL(link.href)
}